console.log('load rmid.js');


auth0_login = function(signup = false){
  const urlParams = new URLSearchParams(window.location.search);
  let checkout_url = urlParams.get('checkout_url');
  let redirect_uri = location.origin;
  if (redirect_uri.endsWith('/')) {
    redirect_uri = redirect_uri.slice(0, -1);
  }
  let href=`https://login.rittor-music.co.jp/authorize?response_type=code&client_id=HEf6fBN2jR4MlhHbsmVA9YAnffTc8DTM&scope=offline_access&state=STATE&redirect_uri=${redirect_uri}`;
  if (checkout_url) {
//    if (checkout_url.includes('?')) {  // 仮処置： クエリパラメータを消してしまう。
//      checkout_url = checkout_url.split('?')[0];
//    }
    // redirect_uri = `${redirect_uri}${checkout_url}`
    // redirect_uri = encodeURIComponent(redirect_uri);
    redirect_uri = `${redirect_uri}/cart`;
    href=`https://login.rittor-music.co.jp/authorize?response_type=code&client_id=HEf6fBN2jR4MlhHbsmVA9YAnffTc8DTM&scope=offline_access&state=STATE&redirect_uri=${redirect_uri}`;
  } else {
    href=`https://login.rittor-music.co.jp/authorize?response_type=code&client_id=HEf6fBN2jR4MlhHbsmVA9YAnffTc8DTM&scope=offline_access&state=STATE&redirect_uri=${location.origin}`;
  }

  const uuid = crypto.randomUUID();
  href = href.replace('&state=STATE', `&state=${uuid}`);
  
  if (signup){
    href += '&screen_hint=signup';
  }
  console.log(`href = ${href}`);
  location.href = href;
}


const signup = (location.pathname === '/account/register')
auth0_login(signup);
